<template>
  <div class="analytics-item" :class="blockClass" :style="blockStyle">
    <div class="ver-padding-30 hor-padding-40 grid cross-start">
      <div class="r-margin-20" v-if="false">
        <b-dropdown aria-role="list">
          <button
            class="button options is-primary"
            slot="trigger"
            slot-scope="{ active }"
          >
            <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
          </button>

          <b-dropdown-item aria-role="listitem">Предприятия</b-dropdown-item>
          <b-dropdown-item aria-role="listitem">Терминалы</b-dropdown-item>
          <b-dropdown-item aria-role="listitem">Продукт карты</b-dropdown-item>
          <b-dropdown-item aria-role="listitem"
            >Страна пользователя</b-dropdown-item
          >
          <b-dropdown-item aria-role="listitem"
            >Город пользователя</b-dropdown-item
          >
          <b-dropdown-item aria-role="listitem">Страна банка</b-dropdown-item>
          <b-dropdown-item aria-role="listitem">Валюта</b-dropdown-item>
          <b-dropdown-item aria-role="listitem">Банки</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="u">
        <div class="conversion">
          <animate-number
            from="0"
            :to="data.width"
            duration="2000"
            easing="easeOutQuad"
            :formatter="conversionFormat"
          ></animate-number>
          <span>%</span>
        </div>

        <div class="amount">
          <animate-number
            from="0"
            :to="data.amount"
            duration="2000"
            easing="easeOutQuad"
            :formatter="amountFormat"
          ></animate-number>
          <span class="currency-symbol">{{currency}}</span>
        </div>

        <div class="total">
          <animate-number
            from="0"
            :to="data.total"
            duration="2000"
            easing="easeOutQuad"
            :formatter="totalFormat"
          ></animate-number>
          <span class="total-name">({{ data.name | dataName }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueAnimateNumber from "vue-animate-number";
Vue.use(VueAnimateNumber);

export default {
  name: "analyticsRowBlock",
  props: ["data", "blockWidth", "blockClass", "currency"],
  data() {
    return {
      maxWidth: 75
    };
  },
  methods: {
    totalFormat(num) {
      return num
        .toFixed(0)
        .toString()
        .replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
    },
    conversionFormat(num) {
      return (num * 100).toFixed(2);
    },
    amountFormat: function(num) {
      num = (num / 100).toFixed(2);
      return num.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
    }
  },
  computed: {
    blockStyle() {
      if (this.blockClass == "success-orders") {
        let width = 50;
        if (this.blockWidth >= 0.25) width = this.blockWidth * 100;
        if (this.blockWidth > 0 && this.blockWidth < 0.25) width = 25;
        let maxWidth = width == 0 || width == 100 ? width : this.maxWidth;
        return "width:" + width.toFixed(0) + "%;max-width:" + maxWidth + "%";
      }
    }
  },
  filters: {
    dataName(value) {
      if (value == "success") return "успешные заказы";
      if (value == "fail") return "неуспешные заказы";
      return value;
    }
  }
};
</script>

<style lang="sass" scoped>
.options
  background: transparent
  border: 2px solid white
  &:hover
    background: rgba(0,0,0,.1)
.currency-symbol
  font-family: Roboto, Helvetica, sans-serif
</style>
